<template>
  <div />
</template>

<script>
import { mapMutations } from 'vuex'
import { user_token_auth } from '@/api/login'
import qs from 'qs'
import { Ctv } from '@/utils'
import Cookies from 'js-cookie'

export default {
  beforeRouteEnter(to, from, next) {
    if (to.path !== '/userauth') return
    next(vm => {
      new Ctv(vm.code, {
        wait: 0,
        success: v => {
          if (v === 200) {
            vm.$router.replace(from.path)
          }
        },
        fail: (first, instance) => {
          if (!first) {
            instance.handle(vm.code)
          }
        }
      })
    })
  },
  data() {
    return {
      code: null
    }
  },
  created() {
    const { token } = this.$route.params
    // 表示从父级站点跳转过来，如果父站点已登录直接授权子站点登录
    if (token) {
      this.userAuth(token)
    }
  },

  methods: {
    ...mapMutations({
      setUserinfo: 'user/setUserinfo',
      setToken: 'user/setToken',
      setTokenExpTime: 'app/setTokenExpTime'

    }),
    // 登录授权
    async userAuth(token) {
      const { data, code } = await user_token_auth(qs.stringify({
        token: token
      }))

      this.setToken(data.token)
      this.setTokenExpTime()

      this.code = code
      this.setUserinfo(data || {})
    }
  }
}
</script>

<style>

</style>
